import { noop } from 'lodash';
import { createContext, Dispatch } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

import { FamilyTreeAction, FamilyTreeState } from '../types';

export interface FamilyTreeContext {
  dispatch: Dispatch<FamilyTreeAction>;
  state: FamilyTreeState;
  getState: () => FamilyTreeState;
  onAfterEdit?: () => void;
}

const defaultState: FamilyTreeState = {
  householdId: '',
  nodes: [],
  edges: [],
  isInitializingFlowchart: true,
  selectedPersonId: undefined,
  isSidePanelOpen: false,
  sidePanelVariant: undefined,
  visualizationConfig: {
    showAge: true,
    showHiddenIndividuals: true,
    showNotes: true,
    showStateOfResidence: true,
  },
  nodeConfigs: {},
  nodePositions: [],
  hasUnsavedNodePositions: false,
  presentationMode: false,
  isInEditMode: false,
  isExporting: false,
  renderWhiteLabeled: false,
};

export const DEFAULT_FAMILY_TREE_STATE: Readonly<FamilyTreeState> =
  Object.freeze(defaultState);

export const FamilyTreeContext = createContext<FamilyTreeContext>({
  dispatch: noop,
  state: { ...DEFAULT_FAMILY_TREE_STATE },
  getState: () => ({ ...DEFAULT_FAMILY_TREE_STATE }),
});

export const useFamilyTreeContext = () => {
  return useGuardedContext(FamilyTreeContext, 'FamilyTreeProvider');
};
